import { SelectEditor } from './selectEditor';
export class MultipleSelectEditor extends SelectEditor {
    /**
     * Initialize the Editor
     */
    constructor(args) {
        super(args, true);
        this.args = args;
    }
}
//# sourceMappingURL=multipleSelectEditor.js.map